import * as React from "react";

function EUPrototype(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0)">
            <path d="M14 0.499994C21.4552 0.499994 27.5 6.54478 27.5 14C27.5 21.4552 21.4552 27.5 14 27.5C6.54478 27.5 0.5 21.4552 0.5 14C0.5 6.54478 6.54478 0.499994 14 0.499994Z" fill="#FFEC42" stroke="#FDE613"/>
            <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="6" y="5" width="17" height="16">
                <path d="M14.224 13.9358C13.7906 13.9358 13.44 13.5841 13.44 13.1518V10.0158C13.44 9.58347 13.7906 9.23179 14.224 9.23179C14.6564 9.23179 15.008 9.58235 15.008 10.0158V13.1518C15.008 13.5841 14.6564 13.9358 14.224 13.9358ZM14.224 15.5038C14.6564 15.5038 15.008 15.8543 15.008 16.2878C15.008 16.7212 14.6564 17.0718 14.224 17.0718C13.7906 17.0718 13.44 16.7212 13.44 16.2878C13.44 15.8543 13.7906 15.5038 14.224 15.5038ZM14.8882 7.15867C14.8255 7.05899 14.7404 6.97275 14.6384 6.91003C14.2722 6.68043 13.7895 6.79243 13.5588 7.15867L7.91731 17.4403C7.84003 17.5646 7.79859 17.7079 7.79859 17.8558C7.79859 18.2892 8.14915 18.6387 8.58259 18.6387H19.8644C20.0122 18.6387 20.1556 18.5972 20.2799 18.5211C20.6472 18.2915 20.7592 17.8076 20.5296 17.4403L14.8882 7.15867ZM16.2176 6.32875L21.8591 16.6092C22.5479 17.7102 22.213 19.1617 21.1109 19.8505C20.7368 20.0846 20.3056 20.2078 19.8644 20.2078H8.58259C7.28339 20.2078 6.23059 19.155 6.23059 17.8558C6.23059 17.4134 6.35379 16.9833 6.58787 16.6092L12.2293 6.32875C12.917 5.22667 14.3685 4.89179 15.4695 5.58059C15.7741 5.76987 16.0295 6.02523 16.2176 6.32875Z" fill="white"/>
            </mask>
            <g mask="url(#mask0)">
                <path d="M23.632 3.74379H4.81604V22.5598H23.632V3.74379Z" fill="#454F5B"/>
            </g>
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="28" height="28" fill="white"/>
            </clipPath>
        </defs>
    </svg>
  );
}

export default EUPrototype;

